import { type ReactNode } from 'react';
import { Box, Flex } from '@radix-ui/themes';
import { VersionLabel } from '@/components/common';

interface WizardScreenProps {
  children: ReactNode;
  header?: ReactNode;
  bgPicture?: string;
}

/** Wizard screen shell: optional header and scrollable body. Primary CTAs live in children. */
export function WizardScreen({ children, header, bgPicture }: WizardScreenProps) {
  return (
    <Flex
      direction="column"
      flexGrow="1"
      minHeight="0"
      height="100%"
      overflow="hidden"
      position="relative"
    >
      {bgPicture && (
        <>
          <img
            src={bgPicture}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 size-full object-cover object-center"
          />
          <div className="bg-picture-scrim absolute inset-0" aria-hidden />
        </>
      )}

      {header && (
        <Box flexShrink="0" width="100%" pt="5" position="relative">
          {header}
        </Box>
      )}

      <Box
        flexGrow="1"
        minHeight="0"
        overflow="auto"
        px="5"
        position="relative"
        className="scrollbar-none"
      >
        {children}
      </Box>

      <Box flexShrink="0" p="2" position="relative" alignSelf="end">
        <VersionLabel />
      </Box>
    </Flex>
  );
}

export type { WizardScreenProps };
